import { EditButton, TopSubmitBlock } from 'shared/ui/Button';

export const TopFormButtons = ({
  isEditSkill,
  onCancelForm,
  isUpdatingEntity,
  toggleSkillEdit,
  getDisableButtonStatus,
}) =>
  isEditSkill ? (
    <TopSubmitBlock
      onCancelForm={() => onCancelForm()}
      isDisabledSubmit={getDisableButtonStatus()}
      isDisabledCancel={isUpdatingEntity}
      submitText={translate('Submit')}
      cancelText={translate('Cancel')}
    />
  ) : (
    <EditButton toggleEditMode={toggleSkillEdit} buttonText={translate('Edit')} />
  );
